<template>

   <div>
      <div class="categoryvideo categoryvideo--active">      
         <div class="categoryvideo__wrap">
            <video autoplay loop muted>
               <source v-bind:src="category.categoryVideo" type="video/mp4">
            </video>
         </div>

         <div class="categoryvideo__close" @click="closeVideoPopup">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512">
               <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path>
            </svg>
            <span>Close</span>
         </div>
      </div>
      <div class="categoryvideo__under categoryvideo__under--active"></div>
   </div>

</template>

<script>
   export default {
      name: 'categoryVideo',
      props: ['category'],

      methods: {
         closeVideoPopup: function(){
            this.$emit('is-video-active')
         },
      }
   }
</script>